import { ALLOCATED_ASSETS_REQUEST } from "../actions/utilities";
const INITIAL_STATE = {
    getAllocatedAssetLoading: false,
    getAllocatedAssetSuccess: false,
    getAllocatedAssetFailure: false,
    getAllocatedAssetError: null,
    allocatedAssetsList: [],
    addAllocatedAssetLoading: false,
    addAllocatedAssetSuccess: false,
    addAllocatedAssetFailure: false,
    addAllocatedAssetError: null
}

export const allocatedAssetsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ALLOCATED_ASSETS_REQUEST.GET_ALLOCATED_ASSETS_REQUEST:
            return {
                ...state,
                getAllocatedAssetLoading: true,
                getAllocatedAssetSuccess: false,
                getAllocatedAssetFailure: false,
                getAllocatedAssetError: null
            }
        case ALLOCATED_ASSETS_REQUEST.GET_ALLOCATED_ASSETS_SUCCESS:
            return {
                ...state,
                getAllocatedAssetLoading: false,
                getAllocatedAssetSuccess: true,
                getAllocatedAssetFailure: false,
                getAllocatedAssetError: null,
                allocatedAssetsList: action.payload
            }
        case ALLOCATED_ASSETS_REQUEST.GET_ALLOCATED_ASSETS_FAILURE:
            return {
                ...state,
                getAllocatedAssetLoading: false,
                getAllocatedAssetSuccess: false,
                getAllocatedAssetFailure: true,
                getAllocatedAssetError: action.payload
            }
        case ALLOCATED_ASSETS_REQUEST.ADD_ALLOCATED_ASSETS_REQUEST:
            return {
                ...state,
                addAllocatedAssetLoading: true,
                addAllocatedAssetSuccess: false,
                addAllocatedAssetFailure: false,
                addAllocatedAssetError: null
            }
        case ALLOCATED_ASSETS_REQUEST.ADD_ALLOCATED_ASSETS_SUCCESS:
            let allocated = state.allocatedAssetsList;
            action.payload = { ...action.payload, id: state.allocatedAssetsList.length }
            allocated.push(action.payload)
            return {
                ...state,
                addAllocatedAssetLoading: false,
                addAllocatedAssetSuccess: true,
                addAllocatedAssetFailure: false,
                addAllocatedAssetError: null,
                allocatedAssetsList: allocated
            }
        case ALLOCATED_ASSETS_REQUEST.ADD_ALLOCATED_ASSETS_FAILURE:
            return {
                ...state,
                addAllocatedAssetLoading: false,
                addAllocatedAssetSuccess: false,
                addAllocatedAssetFailure: true,
                addAllocatedAssetError: action.payload
            }
        case ALLOCATED_ASSETS_REQUEST.REMOVE_ALLOCATED_ASSETS_REQUEST:
            return {
                ...state,
                addAllocatedAssetLoading: true,
                addAllocatedAssetSuccess: false,
                addAllocatedAssetFailure: false,
                addAllocatedAssetError: null
            }
        case ALLOCATED_ASSETS_REQUEST.REMOVE_ALLOCATED_ASSETS_SUCCESS:
            let allocated_asset = state.allocatedAssetsList;
            for (var i = 0; i < state.allocatedAssetsList.length; i++) {
                if (allocated_asset[i].id === action.payload) {
                    allocated_asset.splice(i, 1)
                }
            }
            return {
                ...state,
                addAllocatedAssetLoading: false,
                addAllocatedAssetSuccess: true,
                addAllocatedAssetFailure: false,
                addAllocatedAssetError: null,
                allocatedAssetsList: allocated_asset
            }
        case ALLOCATED_ASSETS_REQUEST.REMOVE_ALLOCATED_ASSETS_FAILURE:
            return {
                ...state,
                addAllocatedAssetLoading: false,
                addAllocatedAssetSuccess: false,
                addAllocatedAssetFailure: true,
                addAllocatedAssetError: action.payload
            }
        case ALLOCATED_ASSETS_REQUEST.EDIT_ALLOCATED_ASSETS_REQUEST:
            return {
                ...state,
                addAllocatedAssetLoading: true,
                addAllocatedAssetSuccess: false,
                addAllocatedAssetFailure: false,
                addAllocatedAssetError: null
            }
        case ALLOCATED_ASSETS_REQUEST.EDIT_ALLOCATED_ASSETS_SUCCESS:
            let allocated_asset_list = state.allocatedAssetsList;
            for (var i = 0; i < state.allocatedAssetsList.length; i++) {
                if (allocated_asset_list[i].id === action.payload.id) {
                    allocated_asset_list[i] = action.payload
                }
            }
            return {
                ...state,
                addAllocatedAssetLoading: false,
                addAllocatedAssetSuccess: true,
                addAllocatedAssetFailure: false,
                addAllocatedAssetError: null,
                allocatedAssetsList: allocated_asset_list
            }
        case ALLOCATED_ASSETS_REQUEST.EDIT_ALLOCATED_ASSETS_FAILURE:
            return {
                ...state,
                addAllocatedAssetLoading: false,
                addAllocatedAssetSuccess: false,
                addAllocatedAssetFailure: true,
                addAllocatedAssetError: action.payload
            }
        default:
            return state
    }
}